export default __webpack_public_path__ + "static/media/pedagogy.3afe753d.png";